export const getActiveTab = (state) => state.header.activeTab;
export const getSearchValue = (state) => state.header.searchValue;
export const getSideBarOpen = (state) => state.header.sideBarOpen;